module.exports = __webpack_public_path__ + "img/scene_smarthome.cfe9071b.webp";